import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { DropdownFieldWUT } from "../../../ui/dropdown-field/dropdown-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const DropdownWUT = ({ options, ...rest }) => {
  const fieldType = FIELD_TYPES.DROPDOWN;
  const dropdownOptions = useMemo(
    () => (options || []).map((option) => ({
      label: option.label,
      value: option.value ?? option.label
    })),
    [options]
  );
  return /* @__PURE__ */ jsx(
    DropdownFieldWUT,
    {
      ...rest,
      fieldType,
      options: dropdownOptions
    }
  );
};
export {
  DropdownWUT
};
//# sourceMappingURL=dropdown-wut.js.map
